"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useBudgetOptions = void 0;
const useQPreferences_1 = __importDefault(require("components/QPreferences/useQPreferences"));
const constants_1 = require("./constants");
const utils_1 = require("./utils");
const useBudgetOptions = (budgetId = '', dashboardRef = null) => {
    var _a, _b, _c;
    const { datasetPreferences, setDatasetPreference } = (0, useQPreferences_1.default)();
    const isToDateColumnEnabled = ((_a = datasetPreferences === null || datasetPreferences === void 0 ? void 0 : datasetPreferences.budgetOptions) === null || _a === void 0 ? void 0 : _a.showToDateColumn) || false;
    const viewState = ((_c = (_b = datasetPreferences === null || datasetPreferences === void 0 ? void 0 : datasetPreferences.budgetOptions) === null || _b === void 0 ? void 0 : _b.viewState) === null || _c === void 0 ? void 0 : _c[budgetId]) || {};
    let budgetView = constants_1.BUDGET_VIEWS.monthly.key;
    if ((viewState === null || viewState === void 0 ? void 0 : viewState.viewType) && dashboardRef !== 'dashboard') {
        budgetView = viewState === null || viewState === void 0 ? void 0 : viewState.viewType;
    }
    const annualSubView = (viewState === null || viewState === void 0 ? void 0 : viewState.subViewType) || constants_1.BUDGET_ANNUAL_SUBVIEWS.budget.key;
    const showFutureMonthDetails = viewState[(0, utils_1.getKeyFutureMonthsVisibility)(viewState === null || viewState === void 0 ? void 0 : viewState.subViewType)] || false;
    return {
        viewState,
        budgetView,
        annualSubView,
        showFutureMonthDetails,
        isToDateColumnEnabled,
        setDatasetPreference,
    };
};
exports.useBudgetOptions = useBudgetOptions;
